<template>
  <article class="contents-content">
    <div class="contents-content__content">
      <div class="content-in-area">
        <h1 class="content__title with--button">
          정류장 설정
          <v-btn v-if="$store.state.userInfo && $store.state.userInfo.writeBus && !addStationMode" @click="addStation" depressed rounded outlined color="secondary" class="ml-5">
            <v-icon>add</v-icon> 정류장 추가
          </v-btn>
        </h1>
        <h1 class="content__title with--button">
          <v-text-field
            v-model="filterText"
            label="정류장이름 검색"
            hide-details/>
        </h1>
        <h1 class="content__title with--button">
          <div style="margin-right: 10px">
            <div v-if="filterCreated===0" class="content-list-image-content">
              <v-btn @click="onOnOffFilterCreated()" small outlined rounded dark color="black">생성날짜 정렬 OFF</v-btn>
            </div>
            <div v-else-if="filterCreated===1" class="content-list-image-content">
              <v-btn @click="onOnOffFilterCreated()" small rounded dark color="black">생성날짜 최신순</v-btn>
            </div>
            <div v-else style="alignment: left; align-content: start; width: 100%">
              <v-btn @click="onOnOffFilterCreated()" small rounded dark color="black">생성날짜 과거순</v-btn>
            </div>
          </div>
          <div style="margin-right: 10px">
            <div v-if="filterUpdated===0" class="content-list-image-content">
              <v-btn @click="onOnOffFilterUpdate()" small outlined rounded dark color="black">갱신날짜 정렬 OFF</v-btn>
            </div>
            <div v-else-if="filterUpdated===1" class="content-list-image-content">
              <v-btn @click="onOnOffFilterUpdate()" small rounded dark color="black">갱신날짜 최신순</v-btn>
            </div>
            <div v-else style="alignment: left; align-content: start; width: 100%">
              <v-btn @click="onOnOffFilterUpdate()" small rounded dark color="black">갱신날짜 과거순</v-btn>
            </div>
          </div>
          <div style="margin-right: 10px">
            <div v-if="filterNeedFix===0" class="content-list-image-content">
              <v-btn @click="onOnOffFilterNeedFix()" small outlined rounded dark color="black">수정 필요 필터 OFF</v-btn>
            </div>
            <div v-else-if="filterNeedFix===1" class="content-list-image-content">
              <v-btn @click="onOnOffFilterNeedFix()" small rounded dark color="black">수정 필요 필터 ON</v-btn>
            </div>
          </div>
          <div style="margin-right: 10px">
            <div v-if="filterRouteGroupOpen===false" class="content-list-image-content">
              <v-btn @click="onOnOffFilterRouteGroup()" small outlined rounded dark color="black">교구 필터 설정 열기</v-btn>
            </div>
            <div v-else-if="filterRouteGroupOpen===true" class="content-list-image-content">
              <v-btn @click="onOnOffFilterRouteGroup()" small rounded dark color="black">교구 필터 설정 완료</v-btn>
            </div>
          </div>
        </h1>
        <v-list-item-group v-if="filterRouteGroupOpen===true" color="primary">
          <v-list-item
            v-for="(route, i) in (routeGroupList || [])"
            :key="i"
            inactive
            class="content-checkbox__item"
            :ripple="false">
            <v-checkbox
              v-model="filterRouteGroup"
              :value=route.id
              :label="route.name" />
          </v-list-item>
        </v-list-item-group>
        <v-container>
          <v-list class="content-list">
            <v-list-item-group color="primary">
              <v-list-item
                v-for="(sta, i) in (stationList || [])
                .filter(x => {
                  if (this.filterNeedFix) {
                    let emptyImage = (x.images || []).length === 0;
                    let emptyLocation = x.lat <= 0 || x.lng <= 0;
                    return emptyImage || emptyLocation
                  } else {
                    return true
                  }
                })
                .filter(x => {
                  let text = false
                  if (this.filterText.trim() === '') {
                    text = true
                  } else {
                    text = x.name.indexOf(this.filterText) > -1
                  }
                  if (text === false) {
                    return false
                  } else {
                    if (filterRouteGroup === undefined || filterRouteGroup.length === 0) {
                      return true
                    } else {
                      for (const i in x.routeGroups) {
                        let rgId = x.routeGroups[i]
                        for (const fgIndex in filterRouteGroup) {
                          let fgId = filterRouteGroup[fgIndex]
                          if (rgId === fgId) {
                            return true
                          }
                        }
                      }
                    }
                    return false
                  }
                }).sort(function(a, b) {
                  if (filterCreated !== 0) {
                    return (a.createdDate < b.createdDate) ? (filterCreated) : (-1 * filterCreated)
                  } else if (filterUpdated !== 0) {
                    return (a.updatedDate < b.updatedDate) ? (filterUpdated) : (-1 * filterUpdated)
                  }
                  return 0
                })"
                :key="i"
                inactive
                class="content-list__item"
                :ripple="false">
                <div class="content-list-text-content">
                  <v-text-field
                    v-if="sta.titleOn === true || sta.id === 0"
                    v-model="sta.name"
                    label="정류장이름"
                    hide-details/>
                  <div
                    v-else
                    @click="onOnOffTitle(sta)"
                    style="margin-right: 10px; margin-top: 10px; flex: 1 1 auto">
                    정류장이름 : {{ sta.name }}
                  </div>
                  <div v-if="sta.id !== 0" class="content-list-date-content">
                    <div>created : {{ sta.createdDate }}</div>
                    <div>updated : {{ sta.updatedDate }}</div>
                  </div>
                  <v-list-item-action v-if="$store.state.userInfo && $store.state.userInfo.writeBus">
                    <v-btn v-if="sta.id !== 0" @click="onOpenMapPick(sta)" small outlined rounded color="black" style="margin-right: 10px">
                      <v-icon small>map</v-icon>
                      위치
                    </v-btn>
                    <v-btn @click="onSaveStation(sta)" small outlined rounded color="blue" style="margin-right: 10px">
                      <v-icon small>save</v-icon>
                      저장
                    </v-btn>
                    <v-btn v-if="sta.id !== 0" @click="onRemoveStation(sta)" small outlined rounded color="error">
                      <v-icon small>delete</v-icon>
                      제거
                    </v-btn>
                  </v-list-item-action>
                </div>
                <div v-if="sta.routeOn && sta.id !== 0" class="content-list-image-content">
                  <v-btn @click="onOnOffRoute(sta)" small outlined rounded dark color="blue">
                    <v-icon small>format_list_bulleted</v-icon>
                    노선 선택 목록 닫기
                    <v-icon small>expand_less</v-icon>
                  </v-btn>
                  <v-list-item-group color="primary">
                    <v-list-item
                      v-for="(route, i) in (routeGroupList || [])"
                      :key="i"
                      inactive
                      class="content-checkbox__item"
                      :ripple="false">
                      <v-checkbox
                        v-model="routeOpenChecks"
                        :value=route.id
                        :label="route.name" />
                    </v-list-item>
                  </v-list-item-group>
                </div>
                <div v-else-if="sta.id !== 0" style="alignment: left; align-content: start; width: 100%">
                  <v-btn @click="onOnOffRoute(sta)" small rounded dark color="blue">
                    <v-icon small>format_list_bulleted</v-icon>
                    노선 선택 목록 열기
                    <v-icon small>expand_more</v-icon>
                  </v-btn>
                  {{ sta.routeGroupTitle }}
                </div>
                <div v-if="sta.pictureOn && sta.id !== 0" class="content-list-image-content">
                  <v-btn @click="onOnOffPicture(sta)" small outlined rounded dark color="green">
                    <v-icon small>photo</v-icon>
                    사진 목록 닫기
                    <v-icon small>expand_less</v-icon>
                  </v-btn>
                  <carousel
                    :key="sta.id"
                    :index="i"
                    :image-object.sync="sta.stationImage"
                    :is-show-remove-button="$store.state.userInfo && $store.state.userInfo.writeBus"
                  />
                </div>
                <div v-else-if="sta.id !== 0" style="alignment: left; align-content: start; width: 100%">
                  <v-btn @click="onOnOffPicture(sta)" small rounded dark color="green">
                    <v-icon small>photo</v-icon>
                    사진 목록 열기
                    <v-icon small>expand_more</v-icon>
                  </v-btn>
                </div>
                <p style="color:red" v-if="(sta.images || []).length === 0">사진이 등록되지 않았습니다. 사진 설정이 필요합니다</p>
                <p style="color:red" v-if="(sta.lat === 0 || sta.lng === 0)">위치가 등록되지 않았습니다. 위치 등록이 필요합니다</p>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-container>
      </div>
    </div>
    <!-- 주차장 입구 위경도 설정 팝업-->
    <v-dialog v-model="locationModal" fullscreen hide-overlay transition="dialog-bottom-transition" class="map-layer">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>정류장 - 위치 설정</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-0">
          <map-pick
            v-if="locationModal"
            :location-data="locationData"
            @closeModal="onCloseMapPick"
            @onSubmitMapPick="onCompleteMapPick"
            :is-show-set-button="$store.state.userInfo && $store.state.userInfo.writeBus"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </article>
</template>

<script>
import eventBus from '../utils/eventBus'
import Carousel from '../components/common/Carousel'
import MapPick from '../components/map/MapPick'
import { image, manager, routeGroup, station } from '@/api'

export default {
  components: {
    Carousel,
    MapPick
  },
  data: () => ({
    filterCreated: 0,
    filterUpdated: 0,
    filterNeedFix: 0,
    filterRouteGroup: [],
    filterRouteGroupOpen: false,
    filterText: '',
    routeGroupList: {},
    stationList: [],
    stationName: '',
    locationData: null,
    mapPickStation: null,
    addStationMode: false,
    activeIndex: null,
    locationModal: false,
    managerList: [],
    routeOpenStation: null,
    routeOpenChecks: []
  }),
  created () {
    this.fetchList()
    this.fetchManagerList()
  },
  methods: {
    searchText () {

    },
    updateStationRouteGroupTitles (sta) {
      let resultStr = ''
      for (const i in sta.routeGroups) {
        for (const r in this.routeGroupList) {
          if (this.routeGroupList[r].id === sta.routeGroups[i]) {
            resultStr = resultStr + '<' + this.routeGroupList[r].name + '>, '
          }
        }
      }
      sta.routeGroupTitle = resultStr
      return resultStr
    },
    async fetchManagerList () {
      const { data } = await manager.list()
      this.managerList = data.map(x => {
        return {
          text: `${x.name} (${x.phone})`,
          value: x.id
        }
      }, [])
    },
    async fetchRouteGroupList () {
      eventBus.$emit('showLoading')
      const { data } = await routeGroup.list()
      this.routeGroupList = data.map(x => {
        return { name: x.name, id: x.id }
      })
      eventBus.$emit('hideLoading')
    },
    async fetchStation () {
      eventBus.$emit('showLoading')
      const { data } = await station.list()
      this.stationList = data
        .map(x => {
          const rgt = this.updateStationRouteGroupTitles(x)
          return {
            ...x,
            routeGroupTitle: rgt,
            stationImage: {
              images: x.images,
              deleteTarget: [],
              addTarget: []
            }
          }
        }, [])
      eventBus.$emit('hideLoading')
    },
    async fetchList () {
      await this.fetchRouteGroupList()
      await this.fetchStation()
    },
    async addStation () {
      const defaultData = {
        id: 0,
        stationImage: {
          images: [],
          deleteTarget: [],
          addTarget: []
        }
      }
      if (!this.stationList) {
        this.stationList = [defaultData]
      } else {
        this.stationList.unshift(defaultData)
      }
      this.addStationMode = true
    },
    async onSaveStation (sta) {
      if (sta.routeOn) {
        this.onOnOffRoute(sta)
      }
      if (sta.pictureOn) {
        this.onOnOffPicture(sta)
      }
      if (sta.id === 0) {
        // eventBus.$emit('alert', { active: true, text: '에러: 정류장 아이디가 0 입니다' })
        await station.create({
          ...sta
        })
        this.addStationMode = false
        this.fetchList()
      } else {
        eventBus.$emit('showLoading')
        this.processDeleteImage(sta.stationImage)
        await this.processAddImage(sta.stationImage)
        sta.images = sta.stationImage.images
        await station.set(sta.id, sta)
        await this.fetchList()
        eventBus.$emit('hideLoading')
        eventBus.$emit('alert', { active: true, text: '저장되었습니다' })
      }
    },
    async onRemoveStation (sta) {
      if (sta.id === 0) {
        for (const i in this.stationList) {
          if (this.stationList[i].id === 0) {
            this.stationList.splice(i, 1)
            break
          }
        }
      } else {
        eventBus.$emit('dialog',
          {
            active: true,
            msg: '정류장을 정말 제거하시겠습니까?',
            okText: '정류장 제거',
            confirmHandler: {
              ok: async () => {
                if (sta.id === 0) {
                  eventBus.$emit('alert', { active: true, text: '에러: 정류장 아이디가 0 입니다' })
                } else {
                  eventBus.$emit('showLoading')
                  await station.delete(sta.id)
                  await this.fetchList()
                  eventBus.$emit('hideLoading')
                }
              }
            }
          }
        )
      }
    },
    async processAddImage (imageObject) {
      for (const i in imageObject.addTarget) {
        const { data } = await image.create(this.makeFileFormData(imageObject.addTarget[i].file))
        imageObject.images.push(data.name)
      }
      return imageObject
    },
    processDeleteImage (imageObject) {
      for (const i in imageObject.deleteTarget) {
        const imageIndex = imageObject.images.indexOf(imageObject.deleteTarget[i])
        imageObject.images.splice(imageIndex, 1)
      }
      return imageObject
    },
    makeFileFormData (file) {
      const formData = new FormData()
      formData.append('sourceFile', file)
      return formData
    },
    onOnOffRoute (sta) {
      if (this.routeOpenStation != null && this.routeOpenStation.id !== sta.id) {
        this.routeOpenStation.routeOn = false
      }
      this.routeOpenStation = sta
      sta.routeOn = sta.routeOn !== true
      if (sta.routeOn) {
        this.routeOpenChecks = sta.routeGroups
      } else {
        sta.routeGroups = this.routeOpenChecks
        this.updateStationRouteGroupTitles(sta)
      }
      this.$forceUpdate()
    },
    onOnOffFilterRouteGroup () {
      this.filterRouteGroupOpen = !this.filterRouteGroupOpen
      for (const frg in this.filterRouteGroup) {
        var fgId = this.filterRouteGroup[frg]
        console.log(fgId)
      }
      this.$forceUpdate()
    },
    onOnOffFilterCreated () {
      this.filterCreated = (this.filterCreated === 0) ? 1 : ((this.filterCreated === 1) ? -1 : 0)
      this.filterUpdated = 0
      this.$forceUpdate()
    },
    onOnOffFilterUpdate () {
      this.filterUpdated = (this.filterUpdated === 0) ? 1 : ((this.filterUpdated === 1) ? -1 : 0)
      this.filterCreated = 0
      this.$forceUpdate()
    },
    onOnOffFilterNeedFix () {
      this.filterNeedFix = (this.filterNeedFix === 0) ? 1 : 0
      this.$forceUpdate()
    },
    onOnOffPicture (sta) {
      sta.pictureOn = !sta.pictureOn
      this.$forceUpdate()
    },
    onOnOffTitle (sta) {
      sta.titleOn = !sta.titleOn
      this.$forceUpdate()
    },
    onOpenMapPick (sta) {
      this.locationData = null
      this.mapPickStation = sta
      if (sta.lat > 0 && sta.lng > 0) {
        this.locationData = {
          lat: sta.lat,
          lng: sta.lng
        }
      }
      this.locationModal = true
    },
    onCompleteMapPick (location) {
      if (this.mapPickStation == null) {
        eventBus.$emit('alert', { active: true, text: '정류장이 없습니다' })
      } else {
        this.mapPickStation.lat = location.lat
        this.mapPickStation.lng = location.lng
        this.locationModal = false
        this.mapPickStation = null
        eventBus.$emit('alert', { active: true, text: '정류장 위치가 설정 되었습니다.' })
      }
    },
    onCloseMapPick () {
      this.locationModal = false
      this.mapPickStation = null
    },
    selectMainItem (index) {
      this.activeIndex = index
    }
  }
}
</script>

<style lang="scss">
  .content-list {
    .v-list-item {
      border: 1px solid #e2e7eb;
      border-top: 0;
      min-height: 10px;
      &:first-child {
        border-top: 1px solid #e2e7eb;
      }
    }
    .content-list__item {
      margin-top: 1px;
      display: flex;
      flex-direction: column;
    }
    .content-checkbox__item {
      margin-top: 1px;
      display: flex;
      flex-direction: column;
      align-content: start;
      align-items: start;
      min-height: 0;
    }
    .content-search {
      font-size: 1.3rem;
      font-weight: 500;
      margin-bottom: 1.5rem;
      letter-spacing: -.25px;
      &.with--button {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
    }
    .content-list-text-content {
      display: flex;
      width: 100%;
    }
    .content-list-image-content {
      width: 100%;
      .file-input-contents {
        padding: 0;
      }
    }
    .content-list-date-content {
      .file-input-contents {
        padding: 0;
      }
    }
    .content--has-menu2 {
      width: 100%;
      max-width: 100%;
    }
    .v-input--selection-controls {
      margin-top: 1px;
    }
    .v-messages {
      min-height: 0;
    }
    .content-in-area {
      width: 100%;
      padding: 3rem;
      background: #ffffff;
      box-shadow: 0 3px 6px 0 rgba(0,0,0,.03);
      min-height: 100%;
    }
  }
  .v-list-item__action--stack {
    flex-direction: row;
  }
</style>
